import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';
import { useApplicationPermissions } from '@atlassian/jira-tenant-context-controller/src/components/application-permissions/index.tsx';

export const useHasActiveSoftwareAccess = (): boolean => {
	const { software } = useAppEditions();
	const { hasSoftwareAccess } = useApplicationPermissions();
	return software !== 'UNLICENSED' && hasSoftwareAccess === true;
};
